var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8833,
    cy: 17.3208,
    r: 16.1408,
    stroke: "#FA5100",
    strokeWidth: 1.89892
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8809 22.2823C15.5239 22.2823 13.269 23.4103 11.8492 25.2993C11.5625 25.6815 11.639 26.2246 12.0213 26.5097C12.4031 26.7991 12.9454 26.723 13.2328 26.3388C14.3271 24.8833 16.0646 24.0147 17.8809 24.0147C19.6969 24.0147 21.434 24.8829 22.5282 26.3388C22.6984 26.5649 22.9583 26.6853 23.2205 26.6853C23.4015 26.6853 23.584 26.6282 23.7398 26.5101C24.122 26.225 24.1985 25.6819 23.9119 25.2997C22.4925 23.4107 20.238 22.2823 17.8809 22.2823Z",
    fill: "#FA5100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4943 15.6167C13.2523 15.2027 12.7244 15.0589 12.31 15.3083C10.3526 16.4554 8.96742 15.8999 8.89323 15.8704C8.46245 15.6781 7.95359 15.8685 7.7551 16.2992C7.55544 16.7323 7.74577 17.2478 8.17966 17.4463C8.22822 17.4696 8.87497 17.7571 9.8993 17.7571C10.7675 17.7571 11.9075 17.55 13.1855 16.7999C13.5977 16.5591 13.7363 16.0285 13.4943 15.6167Z",
    fill: "#FA5100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8807 15.8712C26.8232 15.8921 25.4334 16.4628 23.4636 15.3091C23.0495 15.062 22.5209 15.2058 22.2792 15.6175C22.0373 16.0296 22.1759 16.5599 22.5877 16.8007C23.8653 17.5508 25.0049 17.7578 25.8731 17.7578C26.8978 17.7578 27.5442 17.4704 27.5928 17.4471C28.022 17.2505 28.208 16.7455 28.0165 16.3124C27.8254 15.8816 27.3154 15.6808 26.8807 15.8712Z",
    fill: "#FA5100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.79ea29c561d130b6e5959b8e9eca1481.svg";
export { ForwardRef as ReactComponent };